import config from 'configDir/index';
import { get, putQuery } from './http';

const baseUrl = '/task/query/active';

// 查询待办事件统计
const queryTaskActiveStatService = get(`${baseUrl}/task`, config.workflowServiceUrl);

// 查询待办事件列表
const queryTaskActivePageService = get(`${baseUrl}/task/page`, config.workflowServiceUrl);

// 忽略待办事件
const taskIgnoreService = putQuery('/task/ignore', config.workflowServiceUrl);

// 新工作流查询待办事件
const getListToDoService = get('/workorder/listToDo', config.governanceUrl);

// 新工作流查询待办统计
const getCountListToDoService = get('/workorder/countListToDo', config.governanceUrl);

export {
  queryTaskActiveStatService,
  queryTaskActivePageService,
  taskIgnoreService,
  getListToDoService,
  getCountListToDoService,
};
